import { useState, useEffect } from 'react';
import api from '@/lib/api';
import ApiAuthLocalStorage from '@/lib/api/ApiAuthLocalStorage';
import { type SuperUser } from '@/routes/super-users/types';

const useAuthenticationState = (): [
  boolean,
  SuperUser | null,
  () => Promise<void>,
] => {
  const [loading, setLoading] = useState(true);
  const [authenticatedSuperUser, setAuthenticatedSuperUser] =
    useState<SuperUser | null>(null);

  const refreshAuthenticationState = async () => {
    const accessToken = ApiAuthLocalStorage.getAccessToken();

    if (!accessToken) {
      setAuthenticatedSuperUser(null);
      setLoading(false);

      return;
    }

    try {
      const authenticatedSuperUser = await api.get<SuperUser>('auth/me');

      setAuthenticatedSuperUser(authenticatedSuperUser);
    } catch {
      setAuthenticatedSuperUser(null);

      api.unauthenticate();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    refreshAuthenticationState();
  }, []);

  return [loading, authenticatedSuperUser, refreshAuthenticationState];
};

export default useAuthenticationState;
